module.exports = __webpack_public_path__ + "static/media/Seguridad.bf70d8c4.svg";